module.exports = (__webpack_require__(351725))("./node_modules/router5/dist/index.es.js");